export default __webpack_public_path__ + "atomic/_patterns/02-molecules/view-style-grid/_view-style-grid.twig";